import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./layout/Navbar";
import { Footer } from "./layout/Footer";
import { CatalogModal } from "./components/CatalogModal";
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { ProductsPage } from "./pages/ProductsPage";
import { ManufacturingPage } from "./pages/ManufacturingPage";
import { CertificationsPage } from "./pages/CertificationsPage";
import { ContactPage } from "./pages/ContactPage";
import "./App.css";

function App() {
  const [isCatalogModalOpen, setIsCatalogModalOpen] = useState(false);

  const basename = "/";

  const openCatalogModal = () => setIsCatalogModalOpen(true);
  const closeCatalogModal = () => setIsCatalogModalOpen(false);

  return (
    <BrowserRouter basename={basename}>
      <div className="min-h-screen flex flex-col bg-cream">
        <Navbar onOpenCatalogModal={openCatalogModal} />
        <main className="flex-1">
          <Routes>
            <Route
              path="/"
              element={<HomePage onOpenCatalogModal={openCatalogModal} />}
            />
            <Route path="/about" element={<AboutPage />} />
            <Route
              path="/products"
              element={<ProductsPage onOpenCatalogModal={openCatalogModal} />}
            />
            <Route
              path="/manufacturing"
              element={<ManufacturingPage onOpenCatalogModal={openCatalogModal} />}
            />
            <Route path="/certifications" element={<CertificationsPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
        <CatalogModal isOpen={isCatalogModalOpen} onClose={closeCatalogModal} />
      </div>
    </BrowserRouter>
  );
}

export default App;
